import React, { useState } from 'react';
import './Testimonials.css';

const LANG_FILTERS = ['All', 'Telugu', 'Hindi', 'English'];

const TESTIMONIALS = [
  {
    id: 1, lang: 'Telugu',
    name: 'Suresh Reddy', location: 'Hyderabad',
    service: 'Past Prediction', accuracy: 96, stars: 5,
    quote: 'Tilak garu exact ga chepparu — 3 years back ee situation jarigindi ani. Nenu shock ayyanu. Past prediction ila accurate ga vastundi antara nammaledu.',
  },
  {
    id: 2, lang: 'Hindi',
    name: 'Priya Sharma', location: 'Delhi',
    service: 'Future Consultation', accuracy: 94, stars: 5,
    quote: 'मेरी कुंडली देखकर उन्होंने बताया कि अगले 6 महीने करियर में बड़ा बदलाव आएगा। बिल्कुल सही निकला। VTD Astrology सच में अलग है।',
  },
  {
    id: 3, lang: 'Telugu',
    name: 'Kavitha Naidu', location: 'Vijayawada',
    service: 'Past Prediction', accuracy: 98, stars: 5,
    quote: 'Marriage lo problems, career lo confusion — anni Tilak garu mundu chepparu. Ippudu aa remedies follow avutunnanu, chala difference feel avutundi.',
  },
  {
    id: 4, lang: 'English',
    name: 'Rahul Menon', location: 'Bangalore',
    service: 'Numerology Reading', accuracy: 91, stars: 4,
    quote: 'Very impressed by the accuracy of numerology analysis. My business name change was suggested and within 3 months profits improved significantly. Highly recommend.',
  },
  {
    id: 5, lang: 'Hindi',
    name: 'Anita Gupta', location: 'Mumbai',
    service: 'Tarot Reading', accuracy: 93, stars: 5,
    quote: 'टैरो रीडिंग इतनी सटीक थी कि मैं हैरान रह गई। जो मैंने किसी को नहीं बताया था वो भी उन्हें पता था। VTD Astrology पर पूरा भरोसा है।',
  },
  {
    id: 6, lang: 'Telugu',
    name: 'Venkat Rao', location: 'Tirupati',
    service: 'Remedies by Tilak', accuracy: 97, stars: 5,
    quote: 'Personal ga Tilak garu ee remedy prepare chesaru. Mantra, gemstone anni specific ga chepparu. 40 days lo financial improvement clearly kanipinchindi.',
  },
  {
    id: 7, lang: 'English',
    name: 'Deepa Krishnan', location: 'Chennai',
    service: 'Palmistry Reading', accuracy: 90, stars: 4,
    quote: 'The palmistry reading covered aspects of my life I had never discussed. The health prediction was spot on. Great service at an incredibly reasonable price.',
  },
  {
    id: 8, lang: 'Hindi',
    name: 'Vikram Singh', location: 'Jaipur',
    service: 'Vastu Consultation', accuracy: 92, stars: 5,
    quote: 'घर का वास्तु ठीक करने के बाद परिवार में शांति आ गई। नौकरी में भी सुधार हुआ। Tilak ji की सलाह बहुत व्यावहारिक और असरदार है।',
  },
];

const Testimonials = () => {
  const [activeLang, setActiveLang] = useState('All');

  const filtered = activeLang === 'All'
    ? TESTIMONIALS
    : TESTIMONIALS.filter((t) => t.lang === activeLang);

  const track = [...filtered, ...filtered];

  return (
    <section className="testimonials" id="reviews" aria-label="Client testimonials">
      <div className="testimonials__header">
        <p className="section-eyebrow">Real Stories</p>
        <h2 className="section-title">What Our Clients Say</h2>
        <p className="section-sub">Thousands of lives transformed — across Telugu, Hindi &amp; English communities</p>
        <div className="gold-divider" style={{ maxWidth: 400, margin: '1.5rem auto' }} />

        <div className="testimonials__filters" role="group" aria-label="Filter by language">
          {LANG_FILTERS.map((l) => (
            <button key={l} className={`t-filter${activeLang === l ? ' t-filter--active' : ''}`}
              onClick={() => setActiveLang(l)}>
              {l}
            </button>
          ))}
        </div>
      </div>

      <div className="testimonials__carousel" aria-label="Testimonials carousel">
        <div className="testimonials__track"
          style={{ animationDuration: `${Math.max(track.length * 4, 20)}s` }}>
          {track.map((t, i) => (
            <TestimonialCard key={`${t.id}-${i}`} testimonial={t} />
          ))}
        </div>
      </div>

      <div className="testimonials__cta">
        <p>Join 50,000+ clients who found their path through VTD Astrology</p>
        <a href="/chat" className="btn btn-gold">
          Begin Your Journey — Get Your Reading
        </a>
      </div>
    </section>
  );
};

const TestimonialCard = ({ testimonial: t }) => (
  <article className="t-card" aria-label={`Testimonial from ${t.name}`}>
    <div className="t-card__top">
      <div className="t-card__avatar" aria-hidden="true">{t.name.charAt(0)}</div>
      <div>
        <p className="t-card__name">{t.name}</p>
        <p className="t-card__location">{t.location} · {t.lang}</p>
      </div>
      <div className="t-card__accuracy">
        <span className="t-card__accuracy-val">{t.accuracy}%</span>
        <span className="t-card__accuracy-label">accurate</span>
      </div>
    </div>
    <div className="t-card__stars" aria-label={`${t.stars} out of 5 stars`}>
      {'★'.repeat(t.stars)}{'☆'.repeat(5 - t.stars)}
    </div>
    <p className="t-card__service">Service: {t.service}</p>
    <p className="t-card__quote">"{t.quote}"</p>
  </article>
);

export default Testimonials;
